export default __webpack_public_path__ + "static/media/dummy_resource_image.27efe332.jpg";